import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { Box, makeStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import AlarmOffIcon from '@material-ui/icons/AlarmOff';
import AlarmOnIcon from '@material-ui/icons/AlarmOn';
import CheckIcon from '@material-ui/icons/Check';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  pendente: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#f44336',
  },
  confirmado: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#4caf50',
  },
  cartao: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#00796b',
    marginLeft: '10px',
  },
}));

const StatusField = (props) => {
  const classes = useStyles();
  const record = useRecordContext(props);
  const value = record ? record.record.agendamento_user_id : null;
  const status = record ? record.record.status : false;
  return (
    <div style={{ display: 'flex' }}>
      {value ? (
        <Avatar
          className={classes.confirmado}
          style={{
            fontSize: 15,
            color: status ? 'transparent' : 'white',
            backgroundColor: status ? 'transparent' : '#4caf50',
          }}
        >
          <AlarmOnIcon style={{ fontSize: 15 }} />
        </Avatar>
      ) : (
        <Avatar
          className={classes.pendente}
          style={{
            fontSize: 15,
            color: status ? 'transparent' : 'white',
            backgroundColor: status ? 'transparent' : '#f44336',
          }}
        >
          <AlarmOffIcon style={{ fontSize: 15 }} />
        </Avatar>
      )}
    </div>
  );
};

StatusField.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

export default StatusField;
